import { render, staticRenderFns } from "./curriculumCatalog.vue?vue&type=template&id=3583d97a&scoped=true"
import script from "./curriculumCatalog.vue?vue&type=script&lang=js"
export * from "./curriculumCatalog.vue?vue&type=script&lang=js"
import style0 from "./curriculumCatalog.vue?vue&type=style&index=0&id=3583d97a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583d97a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3583d97a')) {
      api.createRecord('3583d97a', component.options)
    } else {
      api.reload('3583d97a', component.options)
    }
    module.hot.accept("./curriculumCatalog.vue?vue&type=template&id=3583d97a&scoped=true", function () {
      api.rerender('3583d97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/curriculumCatalog.vue"
export default component.exports